import colors from 'styles/themes/wikifactory/styles/colors';

const orderStatuses = {
  CREATED: {
    title: 'Created',
    color: colors.wfYellow,
  },
  // For the sake of old Orders that need to be migrated
  Created: {
    title: 'Created',
    color: colors.wfYellow,
  },
  IN_PRODUCTION: {
    title: 'In production',
    color: colors.wfPurple,
  },
  SHIPPED: {
    title: 'Shipped',
    color: colors.wfGreen,
  },
  DELIVERED: {
    title: 'Delivered',
    color: colors.wfBlue,
  },
  RECEIVED: {
    title: 'Received',
    color: colors.wfBlue,
  },
  CANCELLED: {
    title: 'Cancelled',
    color: colors.wfBlack,
  },
};

export type OrderStatus = keyof typeof orderStatuses;

export default orderStatuses;
